export interface DictionaryUnitConverterEntity {
  Id: number | undefined;
  Unit: string;
  Factor: number;
}

